/* Progressive enhancement; commerce is handled by Shopify's native theme components. */
document.addEventListener('click', event => {
  const view = event.target.closest('[data-vh-view]');
  if (view) {
    const active = view.getAttribute('aria-pressed') !== 'true';
    view.setAttribute('aria-pressed', String(active));
    view.closest('.vh-product__media').classList.toggle('is-alternate', active);
  }
  const filter = event.target.closest('[data-filter]');
  if (!filter) return;
  const region = filter.closest('[data-vh-filter]');
  if (!region) return;
  region.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
  let count = 0;
  region.querySelectorAll('[data-category]').forEach(card => {
    card.hidden = filter.dataset.filter !== 'All' && card.dataset.category !== filter.dataset.filter;
    if (!card.hidden) count++;
  });
  region.querySelector('[data-filter-status]').textContent = `${count} collection previews shown.`;
});

document.addEventListener('change', event => { if (event.target.matches('[data-vh-currency]')) event.target.form.requestSubmit(); });
